<template>
  <div>
    <div
      @click="handleClick"
      :class="isActive ? 'active_dropdown-item' : 'dropdown-item'"
      :style="{ paddingLeft: (level * 20 + 10) + 'px' }"
      :title="item.label || item.text"
    >
      <p style="flex:1;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">{{ item.label || item.text }}</p>
      <template v-if="hasChildren">
        <span style="flex-shrink:0;margin-left:8px;display:inline-flex;align-items:center;">
          <i :class="expanded ? 'el-icon-minus' : 'el-icon-plus'" style="font-weight:bold;font-size:18px;"></i>
        </span>
      </template>
      <template v-else>
        <img :src="isActive ? require('@/assets/list/active.png') : require('@/assets/list/actived.png')"
             style="width:24px;height:20px;flex-shrink:0;margin-left:8px;">
      </template>
    </div>
    <div v-if="showChildren" style="background:#f9f9f9;">
      <mobile-menu-item
        v-for="child in item.children"
        :key="child.id"
        :item="child"
        :level="level + 1"
        :active-id="activeId"
        @select="handleChildSelect"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'MobileMenuItem',
  props: {
    item: { type: Object, required: true },
    level: { type: Number, default: 0 },
    activeId: { type: [String, Number], default: '' }
  },
  data() {
    return { expanded: false }
  },
  computed: {
    hasChildren() { return this.item.children && this.item.children.length > 0 },
    isActive() { return String(this.item.id) === String(this.activeId) },
    showChildren() { return this.hasChildren && this.expanded }
  },
  methods: {
    handleClick() {
      if (this.hasChildren) {
        this.expanded = !this.expanded
      }
      this.$emit('select', this.item)
    },
    handleChildSelect(item) {
      this.$emit('select', item)
    },
    deepFind(children, id) {
      for (const c of children) {
        if (String(c.id) === String(id)) return true
        if (c.children && this.deepFind(c.children, id)) return true
      }
      return false
    }
  },
  watch: {
    activeId: {
      immediate: true,
      handler(val) {
        if (!this.hasChildren || !val) return
        const match = String(this.item.id) === String(val) ||
          (this.item.children || []).some(c =>
            String(c.id) === String(val) ||
            (c.children && this.deepFind(c.children, val))
          )
        if (match) this.expanded = true
      }
    }
  }
}
</script>

<style scoped>
.active_dropdown-item{
  padding: 10px;
  cursor: pointer;
  height: 50px;
  font-size: 18px;
  font-weight: bold;
  color: #002b9e;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-left: 3px solid #002b9e;
}
.dropdown-item {
  padding: 10px;
  cursor: pointer;
  height: 50px;
  font-size: 18px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.dropdown-item:hover {
  color: #002b9e;
}
</style>
